import { AUTHORIZATION_HEADER } from '../../../src/authorization';
import { send } from '../../../src/network';
import { type CancelReason } from '../../get_cancel_reasons/get';

export type GetHoldTimePeriodOptionsResponse = CancelReason[];

export async function getHoldTimePeriodOptions() {
  return send<GetHoldTimePeriodOptionsResponse>({
    path: '/api/get_hold_time_period_options',
    method: 'GET',
    headers: new Headers({
      AUTHORIZATION: AUTHORIZATION_HEADER,
    }),
  });
}
